import { apiClient } from '../../services/apiService';
import { RolesActions, RolesActionTypes } from './actionTypes';
import { ActionCreator, Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { IRolesState } from './store';
import { DistributorApiDTO, Role, RolesInfo } from './types';
import { getErrorStatusFromError } from '../users/actions';

export const fetchRolesInfo: ActionCreator<ThunkAction<
  Promise<any>,
  IRolesState,
  null,
  RolesActions
>> = () => {
  return async (dispatch: Dispatch<RolesActions>) => {
    dispatch({ type: RolesActionTypes.CLEAR_ERROR });
    console.log('>> redux > fetchRolesInfo');
    try {
      const { data: rolesInfo } = await apiClient.get<RolesInfo>(
        `/api/usersManagement/roles/info`
      );
      const { data: distributors } = await apiClient.get<DistributorApiDTO[]>(
        '/api/usersManagement/distributors'
      );
      if (rolesInfo.find((x) => x.industryCode === 3) != undefined) {
        rolesInfo.find((x) => x.industryCode === 3)!.remanXpData = {
          portalReference: 'Reman XP Portal',
          distributorInfo: distributors,
        };
      }
      dispatch({
        type: RolesActionTypes.FETCH_ROLES_INFO_SUCCESS,
        rolesInfo,
      });
    } catch (err) {
      dispatch({
        type: RolesActionTypes.FETCH_ROLES_INFO_ERROR,
        status: 500,
      });
    }
  };
};

export const fetchRoles: ActionCreator<ThunkAction<
  Promise<any>,
  IRolesState,
  null,
  RolesActions
>> = () => {
  return async (dispatch: Dispatch<RolesActions>) => {
    dispatch({ type: RolesActionTypes.CLEAR_ERROR });
    console.log('>> redux > fetchRoles');
    try {
      const { data: roles } = await apiClient.get<Role[]>(
        `/api/usersManagement/roles`
      );
      dispatch({
        type: RolesActionTypes.FETCH_ROLES_SUCCESS,
        roles,
      });
    } catch (err) {
      dispatch({
        type: RolesActionTypes.FETCH_ROLES_ERROR,
        status: 500,
      });
    }
  };
};

export const postRole: ActionCreator<ThunkAction<
  Promise<any>,
  IRolesState,
  null,
  RolesActions
>> = (role: Role) => {
  return async (dispatch: Dispatch<RolesActions>) => {
    dispatch({ type: RolesActionTypes.CLEAR_ERROR });
    console.log('>> redux > postRole');
    try {
      const response = await apiClient.post(`/api/usersManagement/roles`, role);
      console.log(response);
      dispatch({
        type: RolesActionTypes.POST_ROLE_SUCCESS,
        role,
        status: response.status,
      });
    } catch (err) {
      dispatch({
        type: RolesActionTypes.POST_ROLE_ERROR,
        status: getErrorStatusFromError(err),
      });
    }
  };
};

export const deleteRole: ActionCreator<ThunkAction<
  Promise<any>,
  IRolesState,
  null,
  RolesActions
>> = (role: Role) => {
  return async (dispatch: Dispatch<RolesActions>) => {
    dispatch({ type: RolesActionTypes.CLEAR_ERROR });
    console.log('>> redux > postRole< <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<');
    try {
      const response = await apiClient.delete(
        `/api/usersManagement/roles/${role.industryName}/${role.name}`
      );
      dispatch({
        type: RolesActionTypes.DELETE_ROLE_SUCCESS,
        role,
        status: response.status,
      });
    } catch (err) {
      dispatch({
        type: RolesActionTypes.DELETE_ROLE_ERROR,
        status: getErrorStatusFromError(err),
      });
    }
  };
};

export const putRole: ActionCreator<ThunkAction<
  Promise<any>,
  IRolesState,
  null,
  RolesActions
>> = (role: Role) => {
  return async (dispatch: Dispatch<RolesActions>) => {
    dispatch({ type: RolesActionTypes.CLEAR_ERROR });
    console.log('>> redux > postRole 2');
    try {
      const response = await apiClient.put(
        `/api/usersManagement/roles/${role.industryName}/${role.name}`,
        {
          priority: role.priority,
          btPortalIndustry: role.btPortalIndustry,
          btPortalIndustryPriorization: role.priority,
          userWebRoles: role.userWebRoles,
        }
      );
      console.log(response);
      dispatch({
        type: RolesActionTypes.PUT_ROLE_SUCCESS,
        role,
        status: response.status,
      });
    } catch (err) {
      dispatch({
        type: RolesActionTypes.PUT_ROLE_ERROR,
        status: getErrorStatusFromError(err),
      });
    }
  };
};
